import { useState, useEffect } from 'react';
import axios from 'axios';
import shrinkImage from '../../utils/shrinkImage';

// Fallback if the categories request fails; the server list (/api/inquiries/categories) is the source of truth
const FALLBACK = [{ key: 'other', label: 'Something Else' }];

let cached = null;
export function useInquiryCategories() {
  const [categories, setCategories] = useState(cached || FALLBACK);
  useEffect(() => {
    if (cached) return;
    axios.get('/api/inquiries/categories').then(r => { cached = r.data; setCategories(r.data); }).catch(() => {});
  }, []);
  return categories;
}

export function categoryLabel(categories, key) {
  return categories.find(c => c.key === key)?.label || key || 'Uncategorized';
}

export const TYPE_LABELS = { sell: '💰 Sell', pawn: '🔄 Pawn', question: '❓ Question' };

export async function uploadInquiryPhoto(file) {
  const data = new FormData();
  data.append('image', await shrinkImage(file));
  const r = await axios.post('/api/upload/inquiry-image', data, { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 60000 });
  return { url: r.data.url, public_id: r.data.public_id };
}

export function formatWhen(ts) {
  // SQLite CURRENT_TIMESTAMP is UTC without a zone marker
  const d = new Date(ts.includes('T') ? ts : ts.replace(' ', 'T') + 'Z');
  const sameDay = d.toDateString() === new Date().toDateString();
  return sameDay ? d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }) : d.toLocaleString([], { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
}
